



import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator';
import MatomoEcommerceView from '@/matomo/MatomoEcommerceView';

@Component
export default class TrackCategoryView extends Vue {

  @Prop({required: false, default: ''})
  public localCategoryName: string;

  public mounted() {
    MatomoEcommerceView.forCategoryView(this.localCategoryName).publish();
  }
}
